import { useEffect, useState } from 'react';

interface IUseElementWithObserverParams {
	selector: string;
	observerOptions?: MutationObserverInit;
	rootElement?: Element | Document | ShadowRoot | null;
	isReady?: boolean;
}

export const useElementWithObserver = ({
	selector,
	observerOptions = { childList: true, subtree: true },
	rootElement = null,
	isReady = true,
}: IUseElementWithObserverParams): HTMLElement => {
	const [foundElement, setFoundElement] = useState<Element | HTMLElement | null>(null);

	useEffect(() => {
		if (foundElement || !isReady) return;

		const rootNode = rootElement || document;

		const observerCallback = () => {
			let el: Element | null = null;

			if (
				rootNode instanceof ShadowRoot ||
				rootNode instanceof Element ||
				rootNode instanceof Document
			) {
				el = rootNode.querySelector(selector);
			} else {
				el = document.querySelector(selector);
			}

			if (el) {
				setFoundElement(el);

				observer.disconnect();
			}
		};

		const observer = new MutationObserver(observerCallback);

		observerCallback();

		observer.observe(rootNode, observerOptions);

		return () => {
			observer.disconnect();
		};
	}, [selector, observerOptions, rootElement, foundElement, isReady]);

	return foundElement as HTMLElement;
};
